<script>
//
export let pageCopy;
export let pageTitle;
export let buttonText;
export let buttonLink;
//
let theTitle;

 if(pageTitle!== null){
	theTitle=pageTitle;

}else{
	theTitle="";
}
</script>

<section>
    <div class="fic--intro-text">

      {#if pageTitle}
        <h2>{@html pageTitle}</h2>
      {/if }
            <!-- <div> -->
            
        	   {@html pageCopy}

   		   
           <div class="fic--cta_small-text_cta fic--button fic--button_cta-small">
            <a href="{buttonLink}" >{ buttonText }</a>
           </div>
       <!--  </div> -->
    </div>    
       
</section>